import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Card, Button, ButtonGroup, Table, Spinner, Offcanvas, Accordion, Dropdown } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import { useSelector, connect, useDispatch } from 'react-redux';
import Loading from 'components/loading/Loading';
import { useMount } from 'ahooks';
import { nascondiOrdiniFatture } from 'features/98/contratti/contrattiSlice';
import { aggiornaCurrentCliente } from 'features/global/globalSlice';
import classNames from 'classnames';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import ExcelExport from 'components/export/ExcelExport';
import { richiediDati, getColonne, contrattiSupp, getFile } from './funzioni';

const { SearchBar } = Search;

const Dettagli = () => {
  const dispatch = useDispatch();

  const { ordini, fatture, mostraOrdiniFatture, currentContratto, caricamentoModale, tipoModale } = useSelector((state) => state.contratti98);

  const [buttonLoading, setButtonLoading] = useState(false);

  const getContent = () => {
    const Item = ({ titolo, testo, last, custom }) => {
      return (
        <div className="h-100 d-flex flex-column justify-content-between">
          {titolo && (
            <h5>
              <strong>{titolo}</strong>
            </h5>
          )}
          {custom || <p>{testo}</p>}
          {!last && <hr />}
        </div>
      );
    };

    if (tipoModale === 'MOVIMENTI') {
      return (
        <>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="text-capitalize">Delivery / invoices</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Accordion>
              {fatture.length ? (
                fatture.map((mov, i) => {
                  return (
                    <Accordion.Item eventKey={i} key={i}>
                      <Accordion.Header>{mov.Documento}</Accordion.Header>
                      <Accordion.Body>
                        <Item
                          titolo=""
                          custom={
                            <Button
                              variant="secondary"
                              className="w-100"
                              size="sm"
                              disabled={buttonLoading}
                              onClick={() => {
                                getFile(
                                  currentContratto,
                                  mov.Documento,
                                  mov.Anno,
                                  () => {
                                    setButtonLoading(true);
                                  },
                                  () => {
                                    setButtonLoading(false);
                                  }
                                );
                              }}
                            >
                              {buttonLoading ? 'Please wait, downloading...' : 'Download'}
                            </Button>
                          }
                        />

                        <Item titolo="Description" testo={mov.Descrizione} />
                        <Row>
                          <Col>
                            <Item titolo="Lotto" testo={mov.Lotto} last />
                          </Col>
                          <Col>
                            <Item
                              titolo="Quantità"
                              testo={`Kg. ${mov.Qta?.toFixed(2)
                                .toString()
                                .split(/(?=(?:\d{3})+(?:\.|$))/g)
                                .join(',')}`}
                              last
                            />
                          </Col>
                          <Col>
                            <Item titolo="Prezzo" testo={`€ ${mov.Unitario?.toFixed(2)}`} last />
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })
              ) : (
                <p>No data</p>
              )}
            </Accordion>
          </Offcanvas.Body>
        </>
      );
    }

    if (tipoModale === 'ORDINI') {
      return (
        <>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="text-capitalize">Orders</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Accordion>
              {ordini.length ? (
                ordini.map((mov, i) => {
                  return (
                    <Accordion.Item eventKey={i} key={i}>
                      <Accordion.Header>{mov.Documento}</Accordion.Header>
                      <Accordion.Body>
                        <Item
                          titolo=""
                          custom={
                            <Button
                              variant="secondary"
                              className="w-100"
                              size="sm"
                              disabled={buttonLoading}
                              onClick={() => {
                                getFile(
                                  currentContratto,
                                  mov.Documento,
                                  mov.Anno,
                                  () => {
                                    setButtonLoading(true);
                                  },
                                  () => {
                                    setButtonLoading(false);
                                  }
                                );
                              }}
                            >
                              {buttonLoading ? 'Please wait, downloading...' : 'Download'}
                            </Button>
                          }
                        />
                        <Item titolo="Descrizione" testo={mov.Descrizione} />
                        <Row>
                          <Col>
                            <Item titolo="Data consegna prevista" testo={mov.DataPrevistaConsegna} last />
                          </Col>
                          <Col>
                            <Item
                              titolo="Quantità"
                              testo={`Kg. ${mov.Qta?.toFixed(2)
                                .toString()
                                .split(/(?=(?:\d{3})+(?:\.|$))/g)
                                .join(',')}`}
                              last
                            />
                          </Col>
                          <Col>
                            <Item titolo="Prezzo" testo={`€ ${mov.Unitario?.toFixed(2)}`} last />
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })
              ) : (
                <p>No data</p>
              )}
            </Accordion>
          </Offcanvas.Body>
        </>
      );
    }

    return 'Tipo modale non riconosciuto';
  };

  useEffect(() => {
    if (currentContratto && currentContratto !== 0) {
      contrattiSupp(currentContratto);
    }
  }, [currentContratto]);

  return (
    <>
      <Offcanvas show={mostraOrdiniFatture} placement="start" onHide={() => dispatch(nascondiOrdiniFatture())}>
        {caricamentoModale ? (
          <Offcanvas.Body>
            <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: 200 }}>
              <Spinner animation="border" />
            </div>
          </Offcanvas.Body>
        ) : (
          getContent()
        )}
      </Offcanvas>
    </>
  );
};

const Contratti98 = ({ dispatch }) => {
  useEffect(richiediDati, []);

  const title = 'Contracts';
  const description = 'An empty page with a boxed horizontal layout.';

  const { caricamentoInCorso, contratti, mostraOrdiniFatture, currentContratto, caricamentoModale } = useSelector((state) => state.contratti98);

  const { currentCliente, clienti } = useSelector((state) => state.global);

  if (caricamentoInCorso)
    return (
      <>
        <HtmlHead title={title} description={description} />
        <Loading />
      </>
    );

  return (
    <>
      <Dettagli />
      <HtmlHead title={title} description={description} />
      <Row>
        <Col>
          {/* Title Start */}
          <section className="scroll-section" id="title">
            <div className="page-title-container">
              <h1 className="mb-0 pb-0 display-4">{title}</h1>
            </div>
          </section>
          {/* Title End */}
          <section className="scroll-section" id="tabella-contratti">
            <div>
              {/* eslint-disable */}
                  <select onChange={(e) => dispatch(aggiornaCurrentCliente(e.target.value))} className="form-select my-3">
                    {clienti &&
                      clienti.map((item, index) => {
                        return (
                          <option key={index} value={item} selected={item === currentCliente}>
                            {item}
                          </option>
                        );
                      })}
                  </select>
                </div>
            <Card>
              <Card.Body>
                {contratti && (
                  <ToolkitProvider keyField="Id_Contratto" data={contratti[currentCliente] || []} columns={getColonne()} search>
                    {(props) => (
                      <div>
                        <div className="d-flex justify-content-between w-100">
                        <SearchBar {...props.searchProps} />
                        <ExcelExport idTabella="tabella-contratti98" /></div>
                        <hr />
                        <BootstrapTable     
                        id="tabella-contratti98"
                        striped bootstrap4 wrapperClasses="table-responsive" {...props.baseProps} />
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </Card.Body>
            </Card>
          </section>
        </Col>
      </Row>
    </>
  );
};

export default connect()(Contratti98);
